import { render, staticRenderFns } from "./IrStatementsList.vue?vue&type=template&id=2a9a286c&"
import script from "./IrStatementsList.vue?vue&type=script&lang=js&"
export * from "./IrStatementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports